import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import FeatureVideo from '../../ui/FeatureVideo'
import featureVideo from '../../../../assets/videos/cursos.mp4'

export default function VideoLessons({ textVariants }) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-8">
      <motion.div
        className="w-full lg:w-1/2 flex flex-col items-start text-left order-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
        variants={textVariants}
      >
        <span className="badge-info mb-6">Trilha de Aprendizado</span>
        <h3 className="text-[24px] md:text-[30px] font-bold text-text-primary tracking-tight mb-4">
          Aulas diretas. Sem juridiquês.
        </h3>
        <p className="text-base md:text-[18px] text-text-secondary leading-relaxed mb-0 md:mb-8">
          <span className="hidden md:inline">
            Videoaulas estruturadas por módulos que vão direto ao ponto prático. Aprenda a se proteger juridicamente enquanto continua salvando vidas. O conhecimento essencial focado na sua rotina real como médico.
          </span>
          <span className="md:hidden">
            Videoaulas por módulos, direto ao ponto. Proteção jurídica focada na sua rotina como médico.
          </span>
        </p>
        <a href="#planos" className="btn-primary group hidden lg:inline-flex">
          Começar a usar agora
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </motion.div>

      <div className="w-full lg:w-1/2 flex items-center justify-center order-2">
        <FeatureVideo videoSrc={featureVideo} label="Trilha de Cursos" />
      </div>

      <div className="w-full lg:hidden order-3">
        <a href="#planos" className="btn-primary group w-full justify-center">
          Começar a usar agora
          <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </div>
    </div>
  )
}
